/// <reference path="presentation.base.ts" />

namespace ui
{
	export namespace Box
	{

		export class Box
			extends ui.base.HTMLPresentation<HTMLElement>
		{

			private	m_TitleP:	ui.base.BaseHTMLElement<HTMLElement>;
			private	m_Title:	Array<JQuery<HTMLElement>|string>;

			public constructor( title_small_caps: boolean = true, descriptor?: ui.base.IBaseHTMLElementDescriptor )
			{
				super( 'box' );

				this.Initialize( descriptor || {} );

				this.m_Title	= new Array<JQuery<HTMLElement>|string>();
				this.m_TitleP	= new ui.base.BaseHTMLElement( 'p' );

				this.m_TitleP.addClass( 'box-title' );

				if ( title_small_caps )
				{
					this.m_TitleP.addClass( 'small-caps' );
				}
			}

			public clearTitle(): void
			{
				this.m_TitleP.empty();
				this.m_Title	= new Array<JQuery<HTMLElement>|string>();
			}

			public addTitle( title: JQuery<HTMLElement>|string ): void
			{
				this.m_Title.push( title );
				this.m_TitleP.append( title );
			}

			public rebuild( root?: ui.base.BaseHTMLElement<HTMLElement>|JQuery<HTMLElement> ): Box
			{
				this.m_Root.empty();

				if ( root )
				{
					this.remove();

					this.appendTo( root );
				}

				this.append( this.m_TitleP );

				return this;
			}

		}

	}
}
